import { SelectSize } from './Select.types';
import { FieldSize } from '../Field';
import { IconSize, MenuSize, TypoVariant } from '@/components';

export const CLEAR_BUTTON_SIZE = {
  [SelectSize.S]: IconSize.M,
  [SelectSize.M]: IconSize.M,
  [SelectSize.L]: IconSize.L,
  [SelectSize.XL]: IconSize.L,
};

export const CHEVRON_ICON_SIZE = {
  [SelectSize.S]: IconSize.M,
  [SelectSize.M]: IconSize.M,
  [SelectSize.L]: IconSize.L,
  [SelectSize.XL]: IconSize.L,
};

export const MENU_SIZE = {
  [SelectSize.S]: MenuSize.S,
  [SelectSize.M]: MenuSize.M,
  [SelectSize.L]: MenuSize.L,
  [SelectSize.XL]: MenuSize.L,
};

export const LABEL_SIZE = {
  [SelectSize.S]: FieldSize.S,
  [SelectSize.M]: FieldSize.M,
  [SelectSize.L]: FieldSize.L,
  [SelectSize.XL]: FieldSize.XL,
};

export const INFO_VARIANT_BY_SIZE = {
  [SelectSize.S]: TypoVariant.BodyMRegular,
  [SelectSize.M]: TypoVariant.BodyMRegular,
  [SelectSize.L]: TypoVariant.BodyLRegular,
  [SelectSize.XL]: TypoVariant.BodyLRegular,
};

export const SELECT_VARIANT_BY_SIZE = {
  [SelectSize.S]: TypoVariant.BodyMRegular,
  [SelectSize.M]: TypoVariant.BodyMRegular,
  [SelectSize.L]: TypoVariant.BodyLRegular,
  [SelectSize.XL]: TypoVariant.BodyXLRegular,
};

export const SELECT_VARIANT_BY_SIZE_READONLY = {
  [SelectSize.S]: TypoVariant.BodyMMedium,
  [SelectSize.M]: TypoVariant.BodyMMedium,
  [SelectSize.L]: TypoVariant.BodyLMedium,
  [SelectSize.XL]: TypoVariant.BodyXLMedium,
};
